import { createSelector } from 'reselect';

const first = (array, defValue) => {
    if (array.length > 0) {
        return array[0];
    }
    return defValue;
};

const accountPageStateSelector = state => state.bookmakersSwitcher.accountPage;

export const currentPageSelector = createSelector(
    accountPageStateSelector,
    accountPage => accountPage.currentPage,
);

const betHistorySelector = createSelector(
    accountPageStateSelector,
    accountPage => accountPage.betHistory,
);

export const currentPageItemsSelector = createSelector(
    [betHistorySelector, currentPageSelector],
    (betHistory, currentPage) => {
        const currentPageItems = betHistory.filter(item => item.page === currentPage);
        const itemsCount = currentPageItems.length;
        const firstItem = first(currentPageItems, {});
        if (itemsCount === 1 && (firstItem.loading || firstItem.errorInfo)) {
            return [];
        }
        return currentPageItems;
    },
);

export const pageIsLoadingSelector = createSelector(
    [betHistorySelector],
    (betHistory) => {
        const betHistoryItems = betHistory.filter(item => item.loading);
        return first(betHistoryItems, {}).loading || false;
    },
);

export const betHistoryErrorsSelector = createSelector(
    [betHistorySelector],
    (betHistory) => {
        const betHistoryItems = betHistory.filter(item => item.errorInfo);
        return first(betHistoryItems, {}).errorInfo || null;
    },
);

export const hasNextPageSelector = createSelector(
    [betHistorySelector, currentPageSelector],
    (betHistory, currentPage) => {
        const page = currentPage + 1;
        const items = betHistory.filter(item => item.page === page);
        const itemsCount = items.length;
        const firstItem = first(items, {});
        if (itemsCount === 1 && (firstItem.loading || firstItem.errorInfo)) {
            return false;
        }
        return itemsCount > 0;
    },
);

export const isPageAfterNextRequestedSelector = createSelector(
    [betHistorySelector, currentPageSelector],
    (betHistory, currentPage) => {
        const page = currentPage + 2;
        const items = betHistory.filter(item => item.page === page);
        const itemsCount = items.length;
        return itemsCount > 0;
    },
);




// WEBPACK FOOTER //
// /src/js/BetHistory/components/betHistory.selectors.js